import { AfterViewInit, Directive, ElementRef, Input, OnChanges, SimpleChanges } from '@angular/core';
import AutoNumeric from 'autonumeric';

@Directive({
    selector: '[thr-auto-numeric]',
    exportAs: 'auto-numeric',
})
export class AutoNumericDirective implements AfterViewInit, OnChanges {
    private _value: any;

    @Input()
    numDecimals = 2;

    @Input()
    currencySymbol = '\u202f€';

    @Input()
    set value(value: number) {
        this.setAutoNumericValue(value);
    }

    get value(): number {
        return this._value ? Number(this._value.rawValue) : 0;
    }

    constructor(private el: ElementRef) {}

    ngAfterViewInit() {
        this._value = new AutoNumeric(this.el.nativeElement, this._value, {
            // allowDecimalPadding: false,
            decimalPlaces: this.numDecimals,
            currencySymbol: this.currencySymbol,
            digitGroupSeparator: '.',
            decimalCharacter: ',',
            decimalCharacterAlternative: '.',
            currencySymbolPlacement: 's',
            negativePositiveSignPlacement: 'p',
        });
    }

    private setAutoNumericValue(value: number) {
        if (!!this._value && !isNaN(value)) {
            this._value.set(value);
        }
    }

    ngOnChanges(changes: SimpleChanges) {
        if ('value' in changes && !isNaN(changes.value.currentValue)) {
            this.setAutoNumericValue(Number(changes.value.currentValue));
        }

        if ('numDecimals' in changes && !!this._value && changes.numDecimals.currentValue) {
            this._value.update({
                decimalPlaces: Number(changes.numDecimals.currentValue),
            });
        }

        if ('currencySymbol' in changes && !!this._value && changes.currencySymbol.currentValue) {
            this._value.update({
                currencySymbol: changes.currencySymbol.currentValue,
            });
        }
    }
}
